import type { ComponentProps } from 'react'

import { inputLabelClasses, outlinedInputClasses, styled, Theme, TextField as TextFieldBase } from '@mui/material'

export const getTextFieldStyles = ({ theme }: { theme: Theme }) => ({
  width: '100%',

  [`& .${outlinedInputClasses.notchedOutline}`]: {
    background: theme.palette.common.white,
    border: 'none',
    borderBottom: '1px solid #525252',
    borderRadius: '4px 4px 0px 0px',
  },

  [`& .${outlinedInputClasses.root}`]: {
    '&.Mui-focused:not(.Mui-error)': {
      [`& .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: theme.palette.primary.main,
      },
    },

    '&.Mui-error': {
      [`& .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: theme.palette.error[500],
      },
    },
  },

  [`& .${outlinedInputClasses.input}`]: {
    height: 23,
    padding: '22px 16px 3px',
    zIndex: 2,

    '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active': {
      // A hack to prevent the background to change when the user
      // uses the autofill feature.
      //
      // Source: https://stackoverflow.com/a/29350537
      transition: 'background-color 5000s ease-in-out 0s',
    },
  },

  [`& .${inputLabelClasses.root}.${inputLabelClasses.outlined}`]: {
    transform: 'translate(16px, 13px) scale(1)',

    '&.Mui-focused:not(.Mui-error)': {
      color: theme.palette.primary.main,
    },

    [`&.${inputLabelClasses.shrink}`]: {
      transform: 'translate(16px, 8px) scale(0.76)',
    },
  },
})

export const StyledTextField = styled(TextFieldBase)(getTextFieldStyles, {
  name: 'TextField',
})

export const TextField = (props: ComponentProps<typeof TextFieldBase>) => {
  const { variant = 'outlined', ...rest } = props

  return <StyledTextField variant={variant} {...rest} />
}
